//
//
//
//
//
//
//

// import Map from "@/components/Map_leaflet";
import Map from "@/components/Map_mapbox";

export default {
  name: "mapview",
  components: {
    Map,
  },
  data () {
    return {
      homepage: false,
    }
  }
};
